import * as turf from '@turf/turf';
import layers from '../../layers';
import drawing from '../map/draw';

class Shapes {
    constructor (area) {
        this.setShape(area);
        this.selectLayers();
    }

    setShape (area) {
        if (area.layerType === 'circle') {
            this._shape = turf.buffer(area.layer.toGeoJSON(), area.layer.getRadius(), { units: 'meters' });
        } else {
            this._shape = area.layer.toGeoJSON();
        }
    }

    addToLayers (type, layer) {
        layer.eachLayer((f) => {
            try {
                if (turf.intersect(this._shape, f)) {
                    $(`#${type}-selection-${f.properties.Id}`).iCheck('check');
                }
            } catch (err) {
                console.log('ERROR: ', err);
            }
        });
    }

    selectLayers () {
        this._features = [];

        const selectedAreasLayer = layers.get('SelectedAreas');
        if (selectedAreasLayer.visible()) {
            this.addToLayers('SelectedAreas', selectedAreasLayer);
        }

        const markedAreaLayer = layers.get('MarkedArea');
        if (markedAreaLayer.visible()) {
            this.addToLayers('MarkedArea', markedAreaLayer);
        }

        const selectedAreasAfterSalesLayer = layers.get('SelectedAreasAfterSales');
        if (selectedAreasAfterSalesLayer.visible()) {
            this.addToLayers('SelectedAreasAfterSales', selectedAreasAfterSalesLayer);
        }

        const markedAreaAfterSalesLayer = layers.get('MarkedAreaAfterSales');
        if (markedAreaAfterSalesLayer.visible()) {
            this.addToLayers('MarkedAreaAfterSales', markedAreaAfterSalesLayer);
        }

        drawing.removeLayer();
    }
}

export default Shapes;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/Shapes.js